
const config = {
  key: 'AIzaSyC1c6Fr0HmWLhA5ZVA64vu8HsfRl5UCOZQ',
  libraries: 'places'
};

export default config
